import { render, staticRenderFns } from "./editSeparationType.vue?vue&type=template&id=09d1f974&scoped=true"
import script from "./editSeparationType.vue?vue&type=script&lang=js"
export * from "./editSeparationType.vue?vue&type=script&lang=js"
import style0 from "./editSeparationType.vue?vue&type=style&index=0&id=09d1f974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1f974",
  null
  
)

export default component.exports